module.exports = __webpack_public_path__ + "static/assets/b86108e6db1c6c32ad39ba422a355ef3.gif";